import { InvoiceAdjustmentUpsertDto, initializedInvoiceAdjustmentUpsertDto } from './invoice-adjustment-upsert.dto';
import { InvoiceHeaderUpsertDto } from './invoice-header-upsert.dto';
import { InvoiceLineItemUpsertDto } from './invoice-line-item-upsert.dto';
import { PaymentHeaderDto, initializedPaymentHeaderDto } from './payment-header.dto';

export interface InvoiceUpsertDto {
  AdjustedAmountDue: number;
  InvoiceHeader: InvoiceHeaderUpsertDto;
  LineItems: Array<InvoiceLineItemUpsertDto>;

  // optional - only used when submitting a new payment on an invoice, won't be returned when loading an upsert dto
  PaymentHeader: PaymentHeaderDto;

  // optional - only used for creating new adjustments
  LineItemAdjustmentHeader: InvoiceAdjustmentUpsertDto;
  PaymentAdjustmentHeader: InvoiceAdjustmentUpsertDto;

  // optional - populated on the multi-AP credit card payment path; one PaymentHeader per accounting package/gateway group
  PaymentHeaders?: PaymentHeaderDto[];
}

export function initializedInvoiceUpsertDto() {
  return {
    InvoiceHeader: {} as InvoiceHeaderUpsertDto,
    LineItems: new Array<InvoiceLineItemUpsertDto>(),
    PaymentHeader: initializedPaymentHeaderDto(),
    LineItemAdjustmentHeader: initializedInvoiceAdjustmentUpsertDto(),
    PaymentAdjustmentHeader: initializedInvoiceAdjustmentUpsertDto(),
  } as InvoiceUpsertDto;
}
